/** Device-local day-close records — pure storage layer (no network, no React). */

export interface DayCloseRecord {
  date: string;
  total: number;
  done: number;
  efficiency: number;
  moved: number;
  closedAt: string;
}

const KEY = "nelurio.dayclose.v1";

export function localDateKey(date: Date) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
}

export function readCloses(): Record<string, DayCloseRecord> {
  try {
    const value = JSON.parse(window.localStorage.getItem(KEY) ?? "{}");
    return value && typeof value === "object" ? value : {};
  } catch {
    return {};
  }
}

export function writeClose(record: DayCloseRecord) {
  const all = readCloses();
  all[record.date] = record;
  try { window.localStorage.setItem(KEY, JSON.stringify(all)); } catch { /* ignore */ }
}

/** Weekly efficiency history (last 7 days) from close records. */
export function weekEfficiency(): Array<{ date: string; efficiency: number }> {
  const closes = readCloses();
  const out: Array<{ date: string; efficiency: number }> = [];
  const base = new Date();
  for (let offset = 6; offset >= 0; offset -= 1) {
    const date = new Date(base.getFullYear(), base.getMonth(), base.getDate() - offset);
    const key = localDateKey(date);
    out.push({ date: key, efficiency: closes[key]?.efficiency ?? -1 });
  }
  return out;
}
